import { XhttpRequest, ShowRequestResp } from './_request.js';

const urlSessionControl = '/util/php/class.sessionControl.php';
const urlModuleUsers    = '/util/php/class.moduleUsers.php';
const urlSendMail       = '/util/php/sendSMTP-Mail.php';

export function showFormContact() {
    document.getElementById('HDivContact').classList.add('active');
}

export function hideFormContact() {
    document.getElementById('HDivContact').classList.remove('active');
}

export function ActiveFormContactTop(element) {
    const divElement = document.getElementById(element);
    if (divElement.classList[0] == 'active') {
        divElement.classList.remove('active');
    } else {
        divElement.classList.add('active');
    }
}

export function QuitSession() {
    fetch(urlSessionControl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'callFunction=LogOut&csrf_token=' + encodeURIComponent(window.csrfToken || ''),
    })
        .then(response => response.text())
        .then(data => {
            if (data.trim() == '1') {
                window.location.href = '/';
            } else {
                console.error('Logout error:', data);
                const wrongMsg = document.getElementById('WrongMessage');
                if (wrongMsg) wrongMsg.innerHTML = data;
            }
        })
        .catch(error => console.error('Request failed', error));
}

function deleteAdminRecord(urlProcessor, callFunction, recordId, confirmMessage, protectedMessage) {
    if (!confirm(confirmMessage)) return;

    fetch(urlProcessor, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'callFunction=' + callFunction + '&action=eliminar&csrf_token=' + encodeURIComponent(window.csrfToken || '') + '&attachedData=' + encodeURIComponent(recordId),
    })
        .then(response => response.text())
        .then(data => {
            const response = data.trim();
            if (response === '1') {
                window.location.reload();
            } else if (response === '2' && protectedMessage) {
                alert(protectedMessage);
            } else {
                alert(response || 'No fue posible eliminar el registro.');
            }
        })
        .catch(() => alert('No fue posible procesar la solicitud.'));
}

export function deleteUser(userId) {
    deleteAdminRecord(
        urlModuleUsers,
        'ProcessUserData',
        userId,
        '¿Eliminar este usuario?',
        'No puedes eliminar el último usuario activo.'
    );
}

export function ToggleShowwPass(event, idPass) {
    event.preventDefault();
    const pass = document.getElementById(idPass);
    pass.type = pass.type == 'password' ? 'text' : 'password';
}

export function fillFormDates(objDates) {
    for (const x in objDates) {
        const elem = document.getElementById(x);
        if (!elem) continue;
        if (['text', 'email', 'password', 'number'].includes(elem.type)) {
            elem.value = objDates[x].value;
        } else if (elem.type == 'checkbox') {
            elem.checked = objDates[x].value == 1;
        } else if (elem.type == 'select-one') {
            elem.value = objDates[x].value;
        } else if (elem.type == 'textarea') {
            elem.value = objDates[x].value.replace(/<br><br>/g, '\n\n');
        }
    }
}

export function ValidateSendDates(event, formRequest, inputPrefix, action) {
    event.preventDefault();

    const valMail  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const valPhone = /^[0-9\s]+$/;

    let userData       = [];
    let isFormValid    = true;
    let showMessage    = '';
    const statusMessage = inputPrefix + 'StatusMessage';
    const dataUser     = document.forms[formRequest].querySelectorAll('input[data-ref="userDate"], textarea[data-ref="userDate"], select[data-ref="userDate"]');
    const processedNames = new Set();

    for (const el of dataUser) {
        if (el.type === 'submit') continue;
        const name = el.name;
        if (processedNames.has(name) && el.type === 'radio') continue;
        if (el.type === 'checkbox' && name.endsWith('[]') && !el.checked) continue;
        processedNames.add(name);

        let value = el.value;
        if (el.type === 'radio') {
            const selected = document.querySelector(`input[name="${name}"]:checked`);
            value = selected ? selected.value : '';
        } else if (el.type === 'checkbox') {
            value = el.checked ? (el.value || '1') : '0';
        }

        userData.push({
            dataName:  name,
            dataValue: value,
            dataType:  el.type,
            dataLabel: el.dataset.name || el.getAttribute('data-label') || name,
            required:  el.required,
            elementId: el.id,
        });
    }

    for (const element of userData) {
        const inputUI = element.dataType === 'radio'
            ? document.getElementsByName(element.dataName)[0]
            : document.getElementById(element.elementId);

        if (!inputUI) continue;
        inputUI.classList.remove('form-field--error');
        const fieldWrapper = inputUI.closest('.form-field, .divBox');
        if (fieldWrapper) fieldWrapper.classList.remove('form-field--error');

        if (element.required && (!element.dataValue || element.dataValue.toString().trim() === '')) {
            showMessage = 'El campo ' + element.dataLabel + ' es obligatorio';
            isFormValid = false;
            if (element.dataType === 'radio') {
                inputUI.closest('.form-field, .divBox').classList.add('form-field--error');
            } else {
                inputUI.classList.add('form-field--error');
                inputUI.focus();
            }
            break;
        }

        if (element.dataValue) {
            if (element.dataType === 'email' && !valMail.test(element.dataValue)) {
                showMessage = 'Formato de correo no válido en ' + element.dataLabel;
                inputUI.classList.add('form-field--error');
                isFormValid = false;
                break;
            }
            if (element.dataType === 'tel' && !valPhone.test(element.dataValue)) {
                showMessage = 'El teléfono en ' + element.dataLabel + ' solo debe contener números';
                inputUI.classList.add('form-field--error');
                isFormValid = false;
                break;
            }
        }

        if ((formRequest === 'FormRegistroU' || formRequest === 'FormNewPass') && isFormValid) {
            const p1   = formRequest === 'FormRegistroU' ? 'users_password' : 'FResPass';
            const p2   = p1 + '_validate';
            const pass1 = document.getElementById(p1);
            const pass2 = document.getElementById(p2);
            if (pass1 && pass2 && pass1.value !== pass2.value) {
                showMessage = 'Las contraseñas no coinciden.';
                pass1.classList.add('form-field--error');
                isFormValid = false;
                break;
            }
        }
    }

    if (!isFormValid) {
        document.getElementById(statusMessage).innerHTML = `<span style="color:red;">${showMessage}</span>`;
        return;
    }

    document.getElementById(statusMessage).innerHTML = 'Procesando...';
    let sendFormData = '';

    if (formRequest === 'FormLogin') {
        sendFormData = 'callFunction=LogIn&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlSessionControl, formRequest, statusMessage, sendFormData, _loginResp);
    } else if (formRequest === 'FormRegistroU') {
        sendFormData = 'callFunction=ProcessUserData&action=' + action + '&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleUsers, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else if (formRequest === 'FormPassRecover') {
        sendFormData = 'callFunction=ProcessRecoveryPass&action=recoveryPass&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleUsers, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else if (formRequest === 'FormNewPass') {
        sendFormData = 'callFunction=ProcessRecoveryPass&action=resetPass&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleUsers, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else {
        sendFormData = 'formRequest=' + formRequest + '&userData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlSendMail, formRequest, statusMessage, sendFormData, ShowRequestResp);
    }

    function _loginResp(xhttp, idForResponse, statusMessage) {
        try {
            const responseDates = JSON.parse(xhttp.responseText);
            if (responseDates.statusEvent == '1') {
                document.getElementById(formRequest).innerHTML = `<div class='info-msg'>${responseDates.messageResponse}</div>`;
                setTimeout(() => location.reload(), 1500);
            } else {
                document.getElementById(statusMessage).innerHTML = responseDates.messageResponse;
            }
        } catch (e) {
            console.error('Error en respuesta JSON:', e);
        }
    }
}
